import getRequestUrl from "./getRequestUrl";
import getConfiguredRequest from "./getConfiguredRequest";
import handleRequestError from "./handleRequestError";

const RECS_SCOPE_VALUE = "saveditems_seesimilar";

export default async ({ productId, authorisationHeader, retryCallback }) => {
  const requestUrl = getRequestUrl({ productId });
  const request = getConfiguredRequest({ retryCallback });
  const headers = {
    Authorization: authorisationHeader,
    "asos-c-recs-scope": RECS_SCOPE_VALUE
  };

  try {
    const { data } = await request.get({
      url: requestUrl,
      headers
    });

    return data;
  } catch (e) {
    return handleRequestError({ error: e });
  }
};
